import type {DalValue, RefInfo} from '@wix/document-services-types'

export interface DetailedValue<T = DalValue> {
    value: T
    path: string[]
}

export type LiteRefInfo = Pick<RefInfo, 'referencedMap' | 'isRefOwner' | 'path' | 'isRelationalSplit'>

export type PartialRefInfo = Pick<LiteRefInfo, 'path'> & Partial<LiteRefInfo>

export interface RefInfoExtendedData {
    readonly noHash?: boolean
    readonly constantValues?: Set<string>
    readonly candidateMaps?: readonly string[]
    readonly mustResolveExactlyOne?: boolean
}

export type UnmarkedRefInfo = Pick<LiteRefInfo, 'referencedMap' | 'path'> &
    Partial<Pick<RefInfo, 'refTypes'>> &
    RefInfoExtendedData

export type ExtendedRefInfo = Partial<LiteRefInfo> & UnmarkedRefInfo & RefInfoExtendedData

export interface ReferredDataItemsIterateeContext {
    item: DalValue
    namespace: string
    itemRefInfo: PartialRefInfo
    refFieldsInfo: ExtendedRefInfo[]
    ownerItem?: DalValue
    originalItem?: DalValue
}
